import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function MonthlySalesHeader() { return ( <ContentHeader title='Monthly Sales Report' /> ) }

export default React.memo(MonthlySalesHeader)
